export enum HeaderOptionTypes {
  OPTIONS = 'OPTIONS',
  ACCESSIBILITY = 'ACCESSIBILITY'
}
